import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getTermsPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/termsAndConditionsBackup.json';

export const TermsAndConditions = ({ contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = backupContent;
  }
  return (
    <div className="terms-page">
      <div className="container--fixed">
        <h1 className="terms-page__title" dangerouslySetInnerHTML={{ __html: content.title }} />
        <h2 className="terms-page__subtitle" dangerouslySetInnerHTML={{ __html: content.subtitle }} />
        <div className="cms-content" dangerouslySetInnerHTML={{ __html: content.text }} />
      </div>
    </div>
  );
};

TermsAndConditions.propTypes = {
  contentStackContent: PropTypes.object
};

const mapStateToProps = (state) => ({
  contentStackContent: getTermsPage(state)
});

export default connect(mapStateToProps)(TermsAndConditions);
